import { render, staticRenderFns } from "./WhyContactPage.vue?vue&type=template&id=ec0d0356&scoped=true"
import script from "./WhyContactPage.vue?vue&type=script&lang=js"
export * from "./WhyContactPage.vue?vue&type=script&lang=js"
import style0 from "./WhyContactPage.vue?vue&type=style&index=0&id=ec0d0356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d0356",
  null
  
)

export default component.exports